<template>
  <v-menu
    offset-overflow
    fixed
    :position-y="position.y"
    :position-x="position.x"
    :value="true"
    :z-index="1"
    :close-on-content-click="false"
    @input="$emit('dismiss')"
  >
    <v-card>
      <v-layout pa-2 row>
        <span class="mr-2" v-html="$t('message.editor.tooltip.anchorLink.enterId')"></span>
        <input
          class="input"
          autofocus
          v-model="anchorId"
          :placeholder="$t('message.editor.tooltip.anchorLink.placeholder')"/>
        <a class="pr-2" :class="{ disabled: !anchorId }" @click="createBlot">
          {{ $t('message.editor.tooltip.anchorLink.save')}}
        </a>
        <template v-if="!creating">
          <v-divider vertical></v-divider>
          <a class="pl-2 pr-2" @click="remove">
            {{ $t('message.editor.tooltip.anchorLink.remove')}}
          </a>
        </template>
      </v-layout>
    </v-card>
  </v-menu>

</template>

<script>
const ANCHOR_ELEMENT = 'anchor-link';

export default {
  props: {
    value: String,
    position: Object,
    quill: Object,
    range: Object,
    creating: Boolean,
    link: Object,
  },
  data() {
    return {
      anchorId: this.value,
    };
  },
  methods: {
    createBlot() {
      // formateamos el id en caso de que éste tenga espacios
      const formattedId = this.anchorId.split(' ').join('-');
      this.quill.insertEmbed(this.range.index, ANCHOR_ELEMENT, formattedId);
      if (!this.creating) {
        this.link.remove();
      }
      this.$emit('dismiss');
    },
    remove() {
      this.link.remove();
      this.$emit('dismiss');
    },
  },
};
</script>

<style scoped>
  a {
    color: #06c;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.5
  }

  .input {
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 13px;
    height: 26px;
    margin: 0 16px 0 8px;
    padding: 3px 5px;
    width: 170px;
  }

</style>
